import { render, staticRenderFns } from "./ShippingStatus.vue?vue&type=template&id=72e5ae98"
import script from "./ShippingStatus.vue?vue&type=script&lang=js"
export * from "./ShippingStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports